// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gj-0";
export var fulfillmentPanelBody = "_gj-1";